module.exports = __webpack_public_path__ + "img/EPM102_R.9ff2b4ee.png";